function money(c){
  if (window.Shopify && Shopify.formatMoney)
    return Shopify.formatMoney(c, (window.theme && theme.moneyFormat) || '${{amount}}');
  return '$' + (c/100).toFixed(2);
}

function getSelected(root){
  const s = [];
  root.querySelectorAll('input[type=radio]:checked').forEach(r => {
    const p = parseInt(r.dataset.optionPosition, 10);
    if (p) s[p-1] = r.value;
  });
  return s;
}

function matchVariant(variants, s){
  return variants.find(v =>
    v.option1 === (s[0] ?? v.option1) &&
    v.option2 === (s[1] ?? v.option2) &&
    v.option3 === (s[2] ?? v.option3));
}

function initMatrix(root){
  const json = root.querySelector('script[type="application/json"]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const section = root.dataset.section;

  function updateVariantId(){
    const current = matchVariant(variants, getSelected(root));
    if (!current) return;
    const idInputs = document.querySelectorAll(
      `#product-form-${section} input[name="id"], input[name="id"][form="product-form-${section}"]`
    );
    idInputs.forEach(input => {
      input.value = current.id;
      input.removeAttribute('disabled');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll(
      `#product-form-${section} .product-form__error-message-wrapper`
    ).forEach(el => el.setAttribute('hidden', ''));
  }

  function updateCards(){
    root.querySelectorAll('.name_swatch').forEach(sw => {
      const input = sw.querySelector('input[type=radio]');
      const label = sw.querySelector('label');
      if (!input || !label) return;

      const s = getSelected(root);
      s[parseInt(input.dataset.optionPosition, 10) - 1] = input.value;
      const v = matchVariant(variants, s);

      // No real variant for this combination -> hide the card completely
      if (!v) { sw.classList.add('variant-combo-hidden'); return; }
      sw.classList.remove('variant-combo-hidden');

      const price = label.querySelector('.variant-price.onetime:not(.compair)');
      if (price) price.innerHTML = money(v.price) + '/<span>' + v.title + '</span>';

      const cmp = label.querySelector('.variant-price.onetime.compair');
      if (cmp){
        if (v.compare_at_price && v.compare_at_price > v.price){
          cmp.classList.remove('hide');
          cmp.innerHTML = '<s>' + money(v.compare_at_price) + '/<span>' + v.title + '</span></s>';
        } else { cmp.classList.add('hide'); }
      }
      const box = label.querySelector('.cst_price');
      if (box){
        box.dataset.vpriceonetime = money(v.price);
        box.dataset.vcomparprice  = v.compare_at_price ? money(v.compare_at_price) : '';
      }
    });
  }

  function onChange(){ updateCards(); updateVariantId(); }
  root.addEventListener('change', onChange);
  onChange();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-radios').forEach(initMatrix);
});